// import qs from 'qs'
import axios from 'axios'
import wx from 'weixin-js-sdk'
import config from './config';

export default function getWXSign() {
    return new Promise((resolve, reject) => {
        let data = {
            url: window.location.href.split('#')[0]
        };
        // axios.post('/mide/weixin/api/signature', data)
        axios.post(`${config.scratchApiRoot}/api/js/signature`, data)
            .then((res) => {
                const data = res.data.data;
                wx.config({
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: data.appid, // 必填，企业号的唯一标识，此处填写企业号corpid
                    timestamp: data.timestamp, // 必填，生成签名的时间戳
                    nonceStr: data.nonceStr, // 必填，生成签名的随机串
                    signature: encodeURIComponent(data.signature), // 必填，签名，见附录1
                    jsApiList: [
                        'updateAppMessageShareData',
                        'updateTimelineShareData',
                        'scanQRCode',
                        'onMenuShareTimeline',
                        'onMenuShareAppMessage',
                        'onMenuShareQQ',
                        'onMenuShareWeibo',
                        'onMenuShareQZone',
                        'chooseImage',
                        'getLocalImgData',
                        'hideMenuItems',
                    ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                });
                wx.ready(() => {
                        resolve()
                    }
                );
                wx.error(() => {

                });
            })
            .catch((error) => {
                reject(error)
            });
    })
}
